import { BOOKING_STATUS } from '../constants/bookingStatus';

export type TripManagementStatusDisplay = {
  label: string;
  className: string;
};

/**
 * Diver-facing booking readiness labels for Trip Management.
 * Kept in one place so list and detail never disagree.
 *
 * BookingState: 0 Pending → Action required, 1 Confirmed → Ready to go, 2 Cancelled.
 */
export const getTripManagementStatus = (
  bookingStatus: number | undefined | null,
): TripManagementStatusDisplay => {
  if (bookingStatus === BOOKING_STATUS.CANCELLED) {
    return {
      label: 'Cancelled',
      className: 'bg-neutral-100 text-neutral-800',
    };
  }

  if (bookingStatus === BOOKING_STATUS.CONFIRMED) {
    return {
      label: 'Ready to go',
      className: 'bg-green-100 text-status-success',
    };
  }

  return {
    label: 'Action required',
    className: 'bg-red-100 text-status-error',
  };
};
